module.exports = __webpack_public_path__ + "media/images/icons/twotone/plus-square-4ffe86c85ddb31de699f35668dc0785a.svg";